<template>
  <div class="memory-page">
    <!-- Header -->
    <div class="page-header">
      <div class="header-left">
        <h2>纪念日</h2>
        <span class="header-sub">{{ list.length ? '即将到来 ' + list.length + ' 项' : '' }}</span>
      </div>
      <div class="header-right" @click="showForm=true">
        <van-icon name="plus" size="22" color="#1989fa"/>
      </div>
    </div>

    <!-- 新增表单弹窗 -->
    <van-popup v-model="showForm" position="bottom" round :style="{height:'88%'}">
      <div class="form-container">
        <div class="form-header">
          <span class="form-cancel" @click="showForm=false">取消</span>
          <span class="form-title">添加纪念日</span>
          <span class="form-done" @click="onSubmit">保存</span>
        </div>
        <van-field v-model="name" name="name" placeholder="名称" :border="false" class="form-name-input" size="large"/>
        <van-field name="dateType" label="日期类型">
          <template #input>
            <van-radio-group v-model="date_type" direction="horizontal">
              <van-radio name="1">公历</van-radio>
              <van-radio name="2">农历</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-model="year" name="year" type="number" label="年份" placeholder="输入年份"/>
        <van-field readonly clickable label="日期" name="date" :value="dateText || '请选择日期'" placeholder="选择日期" @click="showPicker=true"/>
        <van-calendar v-model="showPicker" :min-date="minDate" :max-date="maxDate" type="single" :default-date="currentDate" @confirm="onConfirm" :formatter="formatter"/>
        <van-field name="cycleType" label="周期">
          <template #input>
            <van-radio-group v-model="cycle" direction="horizontal">
              <van-radio name="1">每年</van-radio>
              <van-radio name="0">仅一次</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="dailyRemind" label="30天内每天提醒" label-width="140px">
          <template #input>
            <van-switch v-model="dailyRemind" :active-value="1" :inactive-value="0" active-color="#1989fa"/>
          </template>
        </van-field>
        <van-field v-model="bak" name="bak" label="备注" placeholder="输入备注信息"/>
      </div>
    </van-popup>

    <!-- 即将到来 -->
    <div class="section-title">即将到来</div>
    <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="" :offset="20">
      <div v-if="list.length === 0 && !loading" class="empty-state">
        <van-icon name="clock-o" size="48" color="#c8c9cc" />
        <p>暂无纪念日</p>
      </div>
      <div v-for="item in list" :key="item.id" class="memory-card upcoming">
        <div class="memory-left">
          <div class="memory-name">{{ item.name }}</div>
          <div class="memory-date">{{ item.date }}</div>
          <div class="memory-bak" v-if="item.bak">{{ item.bak }}</div>
        </div>
        <div class="memory-right">
          <span v-if="item.days !== undefined && item.days >= 0" class="countdown" :class="countdownClass(item.days)">
            <template v-if="item.days == 0">今天</template>
            <template v-else>{{ item.days }}天</template>
          </span>
        </div>
      </div>
    </van-list>

    <!-- 已过去 -->
    <div class="section-title section-past">已过去</div>
    <van-list v-model="loading2" :finished="finished2" @load="onLoad2" finished-text="" :offset="20">
      <div v-for="item in list2" :key="item.id + 'past'" class="memory-card past">
        <div class="memory-left">
          <div class="memory-name">{{ item.name }}</div>
          <div class="memory-date">{{ item.date }}</div>
          <div class="memory-bak" v-if="item.bak">{{ item.bak }}</div>
        </div>
      </div>
    </van-list>

    <div v-if="finished2 && list2.length > 0" class="finished-text">没有更多了</div>
    <div class="safe-bottom" />
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Image,
  Grid,
  GridItem,
  Divider,
  Toast,
  Search,
  Popup,
  DatetimePicker,
  ActionSheet,
  Field,
  RadioGroup,
  Radio,
  Picker,
  Button,
  List,
  Step,
  Steps,
  Form,
  Calendar,
  Collapse,
  CollapseItem,
  Switch
} from "vant";

export default {
  components: {
    [Search.name]: Search,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Divider.name]: Divider,
    [Toast.name]: Toast,
    [Calendar.name]: Calendar,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Picker.name]: Picker,
    [Button.name]: Button,
    [List.name]: List,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Form.name]: Form,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Switch.name]: Switch
  },
  data() {
    return {
      showForm: false,
      currentDate: new Date(),
      year: new Date().getFullYear(),
      showPicker: false,
      name: "",
      date: "",
      date_type: "1",
      search: "",
      cycle: "",
      showCyclePicker: false,
      bak: "",
      dailyRemind: 0,
      list: [],
      loading: false,
      finished: false,
      list2: [],
      loading2: false,
      finished2: false,
      pageNum: 1
    };
  },
  computed: {
    dateText() {
      if (!this.date) return "";
      const ds = String(this.date);
      const y = ds.substring(0, 4);
      const m = ds.substring(4, 6);
      const d = ds.substring(6, 8);
      return `${y}年${m}月${d}日`;
    },
    minDate() {
      return new Date(this.year, 0, 1);
    },
    maxDate() {
      return new Date(this.year, 11, 31);
    }
  },
  methods: {
    countdownClass(days) {
      if (days <= 3) return "urgent";
      if (days <= 10) return "soon";
      return "";
    },
    formatter(day) {
      if (this.date_type == 1) return day;
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      const year = day.date.getFullYear();
      var lunar = this.$Lunar.Lunar.toLunar(year, month, date);
      var text = lunar[6];
      if (text == "初一") text = lunar[5];
      day.bottomInfo = text;
      return day;
    },
    onLoad() {
      this.$https.fetchPost("/memory/nextList", {}).then(result => {
        var data = result.data;
        for (var index in data) {
          this.list.push(data[index]);
        }
        this.loading = false;
        this.finished = true;
      });
    },
    onLoad2() {
      this.$https.fetchPost("/memory/list", { pageNum: this.pageNum++ }).then(result => {
        var data = result.data;
        for (var index in data.list) {
          this.list2.push(data.list[index]);
        }
        this.loading2 = false;
        if (data.pageNumber >= data.totalPage) {
          this.finished2 = true;
        }
      });
    },
    onConfirm(date) {
      this.showPicker = false;
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.date = "" + year + month + day;
    },
    onSubmit() {
      var values = {
        name: this.name, dateType: this.date_type, year: this.year,
        date: this.date, cycleType: this.cycle, bak: this.bak,
        dailyRemind: this.dailyRemind
      };
      if (!values.name) { Toast("请输入名称"); return; }
      this.$https.fetchPost("/memory/save", values).then(result => {
        Toast.success("添加成功");
        this.showForm = false;
        this.bak = "";
        this.name = "";
        this.cycle = "";
        this.date = "";
        this.dailyRemind = 0;
        this.year = new Date().getFullYear();
        this.list = [];
        this.list2 = [];
        this.pageNum = 1;
        this.finished = false;
        this.finished2 = false;
        this.onLoad();
        this.onLoad2();
      });
    }
  },
  mounted() {
    this.nickname = this.$cookies.get("nickname");
    this.avatar = this.$cookies.get("avatar");
    var headers = { token: this.$cookies.get("token") };
  }
};
</script>

<style lang="less" scoped>
.memory-page {
  min-height: 100vh;
  background: #f2f2f7;
}

.page-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 12px;
  background: rgba(255,255,255,.72);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);

  .header-left h2 {
    margin: 0 0 4px;
    font-size: 22px;
    font-weight: 700;
    color: #323233;
  }
  .header-sub {
    font-size: 13px;
    color: #999;
  }
  .header-right {
    padding: 8px;
    cursor: pointer;
  }
}

.form-container {
  padding: 0;
  overflow-y: auto;
  height: 100%;
  box-sizing: border-box;
}
.form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f2f2f7;
}
.form-cancel {
  font-size: 17px;
  color: #007aff;
  cursor: pointer;
}
.form-title {
  font-size: 17px;
  font-weight: 600;
  color: #000;
}
.form-done {
  font-size: 17px;
  font-weight: 600;
  color: #007aff;
  cursor: pointer;
}
.form-name-input .van-field__control {
  font-size: 20px;
  font-weight: 600;
}

.form-collapse {
  margin: 10px 14px;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  .van-collapse-item__title {
    font-weight: 600;
    color: #1989fa;
  }
}

.section-title {
  margin: 20px 14px 8px;
  font-size: 16px;
  font-weight: 700;
  color: #323233;
  padding-left: 2px;

  &.section-past {
    color: #999;
  }
}

.memory-card {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 8px 14px;
  padding: 14px 16px;
  background: rgba(255,255,255,.72);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-radius: 10px;

  .memory-left {
    flex: 1;
    min-width: 0;
  }
  .memory-name {
    font-size: 16px;
    font-weight: 600;
    color: #323233;
    margin-bottom: 4px;
    word-break: break-all;
  }
  .memory-date {
    font-size: 12px;
    color: #999;
  }
  .memory-bak {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
    line-height: 1.5;
    word-break: break-all;
  }
  .memory-right {
    flex-shrink: 0;
    margin-left: 12px;
  }
  .countdown {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    background: #f0f5ff;
    color: #1989fa;

    &.urgent {
      background: #fff0f0;
      color: #ee0a24;
    }
    &.soon {
      background: #fff7e6;
      color: #ff976a;
    }
  }

  &.past {
    opacity: 0.6;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  p {
    margin-top: 12px;
    color: #c8c9cc;
    font-size: 14px;
  }
}

.finished-text {
  text-align: center;
  color: #c8c9cc;
  font-size: 13px;
  padding: 16px 0;
}

.safe-bottom {
  height: 20px;
}
</style>
